module.exports = __webpack_public_path__ + "img/136A9440.86372fce.jpg";